var tooltipStyle = {"wrapper":"_h-wrapper-9f46","breakLine":"_h-breakLine-5126","mainBlock":"_h-mainBlock-a40c","line":"_h-line-a757"};

export { tooltipStyle as t };
